import debounce from './debounce';

/**
 * @function resize
 * @description Bind a function to the resize event on window with an automatic default delay.
 *
 * @param {Function} fn The function to run on resize
 * @param {Number} wait The delay for the debouncing of the resize event
 * @param {Boolean} add Whether to add or remove the listener
 */

export default function( fn = () => {}, wait = 200, add = true ) {
	if ( add ) {
		window.addEventListener( 'resize', debounce( fn,  { wait } ) );
	} else {
		window.removeEventListener( 'resize', debounce( fn,  { wait } ) );
	}
};
